import React, { useState } from 'react';

import { Divider, Modal, Row, Table } from 'antd';
import UserProfileForm from './ProfileForm';
import MyButton from './Button';
import CustomerForm from './CustomerForm';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import { ASSET_BASE_PATH } from '../constants/Config';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { FONTS } from '../constants/Font';
import { FormattedMessage } from 'react-intl';

// import { useState } from "react";

const MoreInformationModal = (props) => {
  const { isOpen, onCancle } = props;

  const isDesktop = useIsDesktop();
  const Lang = localStorage.getItem('lang');

  const columns = [
    {
      // title: "น้ำหนัก",
      dataIndex: 'key',
      render: (key) => (
        <Typography color={COLORS.Primary} fontFamily={FONTS.notoSans} size='20px' isBold className='text-center'>
          {key}
        </Typography>
      ),
      align: 'center',
      rowScope: 'row',
    },
    {
      // title: "ราคา",
      dataIndex: 'price',
      render: (price) => (
        <Typography color={COLORS.DarkMidGray} fontFamily={FONTS.notoSans} size='20px' isBold className='text-center'>
          {price}
          {price !== 'ราคา' && '.-'}
        </Typography>
      ),
      align: 'center',
      // onCell: (_, index) => ({
      //   colSpan: index === 1 ? 5 : 1,
      // }),
    },
  ];

  const data = [
    {
      key: 'น้ำหนัก',
      price: 'ราคา',
    },
    {
      key: '1',
      price: 80,
    },
    {
      key: '2',
      price: 90,
    },
    {
      key: '3',
      price: 100,
    },
    {
      key: '4',
      price: 110,
    },
    {
      key: '5',
      price: 120,
    },
    {
      key: '6',
      price: 130,
    },
    {
      key: '7',
      price: 140,
    },
    {
      key: '8',
      price: 150,
    },
    {
      key: '9',
      price: 160,
    },
    {
      key: '10',
      price: 170,
    },
  ];

  return (
    <Modal
      title={
        <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
          {Lang === 'TH' ? (
            <>
               <FormattedMessage id='labelMore' defaultMessage='More' />
              <FormattedMessage id='labelInformation' defaultMessage='Information' />
            </>
          ) : (
            <>
              <FormattedMessage id='labelMore' defaultMessage='More' />
              <FormattedMessage id='labelInformation' defaultMessage='Information' />
            </>
          )}
        </Typography>
      }
      open={isOpen}
      onOk={() => {}}
      onCancel={onCancle}
      width={680}
      footer={[
        <MyButton
          // key="back"
          onClick={onCancle}
          style={{
            width: isDesktop ? '25%' : '100%',
          }}
          isPrimary
          // onClick={isEdit ? handleClickCancelEdit : onCancle}
        >
          <FormattedMessage id='btnClose' defaultMessage='Close' />
        </MyButton>,
      ]}
    >
      <Divider style={{ margin: '0px' }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img
          height={isDesktop ? '80%' : '100%'}
          width={isDesktop ? '80%' : '100%'}
          src={`${ASSET_BASE_PATH}/assets/info.png`}
          alt='logo'
          // style={{ marginRight: "8px", marginLeft: "8px" }}
        />
        <img
          height={isDesktop ? '80%' : '100%'}
          width={isDesktop ? '80%' : '100%'}
          src={`${ASSET_BASE_PATH}/assets/more-information2.png`}
          alt='logo' // style={{ marginRight: "8px", marginLeft: "8px" }}
        />
        <img
          height={isDesktop ? '80%' : '100%'}
          width={isDesktop ? '80%' : '100%'}
          src={`${ASSET_BASE_PATH}/assets/more-information3.png`}
          alt='logo'

          // style={{ marginRight: "8px", marginLeft: "8px" }}
        />
      </div>
      <Divider />
    </Modal>
  );
};

export default MoreInformationModal;
